import { InvoiceSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid}/invoices/{invoiceId} — operator-facing read-only on the
 * dashboard; writes happen server-side via monthlyBilling + (future) Billplz
 * webhook. firestore.rules gates reads to owner|manager|super-admin.
 *
 * Invoice IDs follow YYYY-MM for monthly invoices (Sprint 26); mid-cycle
 * proration-only invoices and refund-credit notes may use nanoid-style ids
 * when they ship.
 */
export function invoicesRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/invoices`,
    schema: InvoiceSchema,
    name: `tenants/${tenantId}/invoices`,
  });
}
